import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { InputItemType, InputSize } from '../../types';

@Component({
  selector: 'app-search-cities-view',
  templateUrl: './search-cities-view.component.html',
  styleUrls: ['./search-cities-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchCitiesViewComponent {
  @Input() city?: InputItemType;
  @Input() size: InputSize = 'm';
  @Input() loading = false;

  cityName?: string;
}
